/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

"use client";

import { useEffect } from "react";

/* 
TODO: Remove `NavigationScrollPaddingFix` after chrome bug is fixed https://issues.chromium.org/issues/374034263,
added as vanilla mittigation for above bug, more info in issue https://jira.it.epicgames.com/browse/MW-8464 
*/

declare global {
	interface Document {
		_cosmosScrollPaddingFix: boolean;
	}
}

export const NavigationScrollPaddingFix = (): React.JSX.Element | null => {
	useEffect(() => {
		if (
			typeof document === "undefined" ||
			!document.documentElement?.style ||
			document._cosmosScrollPaddingFix ||
			!navigator?.userAgent.includes("WebKit")
		)
			return;

		document._cosmosScrollPaddingFix = true;
		const setUnset = (): string => (document.documentElement.style.scrollPaddingTop = "unset");
		const reset = (): string => (document.documentElement.style.scrollPaddingTop = "");

		document.addEventListener("epic-wf-nav-search-input-focus", setUnset);
		document.addEventListener("epic-wf-nav-search-input-blur", reset);

		return () => {
			document.removeEventListener("epic-wf-nav-search-input-focus", setUnset);
			document.removeEventListener("epic-wf-nav-search-input-blur", reset);
			document._cosmosScrollPaddingFix = false;
		};
	}, []);

	return null;
};
